'use strict';

import React, { Component } from 'react';
import uniqid from 'uniqid';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import handleChange from 'Components/Forms/Functions/handleChange';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import TextInput from 'Components/Forms/Elements/TextInput';
import Select from 'Components/Forms/Elements/Select';
import bemit from 'Functions/bemit';
import { num, getSpaceMaxBookable } from 'Shared/utilities';
import { coworking_place_types } from 'Shared/options';
const app = window.app;
const ALL_SPACES_OPT = {
  label: 'Tous nos espaces',
  value: 'all'
};
function getValues(props) {
  const values = {};
  if (app.state.session?.user?.roles?.includes?.('company_employee')) {
    values['widget-space-type'] = 'lounge';
    values.b2b = true;
  } else if (props['from-props'] !== true) {
    values['widget-space-type'] = window.localStorage.getItem('widget-space-type') || 'all';
  } else if (!props.type) {
    values['widget-space-type'] = 'all';
  } else {
    const match = coworking_place_types.find(opt => [opt.value, opt.new_value].includes(props.type));
    values['widget-space-type'] = match ? match.new_value : 'all';
  }
  const [type_options, type_options_key] = getTypesOptions({
    b2b: values.b2b,
    available_spaces_types: props.available_spaces_types
  });
  values.type_options = type_options;
  values.type_options_key = type_options_key;
  const TODAY = moment().format('YYYY-MM-DD');
  values['widget-date'] = props['from-props'] && props.date ? props.date : window.localStorage.getItem('widget-date') || TODAY;
  if (!props['from-props']) {
    window.localStorage.setItem('widget-date', values['widget-date']);
  }
  if (props['from-props']) {
    values['widget-people'] = props.people !== undefined ? props.people || '' : window.localStorage.getItem('widget-people') || '';
  } else {
    values['widget-people'] = window.localStorage.getItem('widget-people') || '';
  }
  return values;
}
function getTypesOptions({
  b2b,
  available_spaces_types
}) {
  if (b2b) {
    const options = coworking_place_types.filter(opt => opt.value === 'lounge').map(opt => ({
      label: opt.widget_label,
      value: 'lounge'
    }));
    return [options, uniqid()];
  }
  const options = [ALL_SPACES_OPT];

  // aucun type présents à l'établissement, on ne laisse que le filtre tous
  if (!Array.isArray(available_spaces_types) || !available_spaces_types.length) {
    return [options, uniqid()];
  }

  // conserve uniquement les types présents à l'établissement
  available_spaces_types.forEach(function (type) {
    const match = coworking_place_types.find(opt => [opt.value, opt.new_value].includes(type));
    if (match) {
      options.push({
        label: match.widget_label,
        value: match.new_value
      });
    }
  });
  return [options, uniqid()];
}
export default class SideWidget extends Component {
  state = {
    loading: false,
    fixed: false,
    status_messages: {},
    roles: app.state.session?.user?.roles || [],
    people_id: uniqid(),
    type_id: uniqid(),
    date_id: uniqid(),
    ...getValues(this.props)
  };
  fixed = false;
  ref = React.createRef();
  date_ref = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'documentScroll',
      cb: component.handleScroll
    });
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    app.push({
      event: 'ShowCustomerWidgetDate',
      cb: component.openDatePicker
    });
    app.push({
      event: 'UpdateSideWidgetDate',
      cb: component.updateDate
    });
    const content = component.ref?.current?.querySelector('.js-widget-content');
    if (content) {
      const top_distance = window.getComputedStyle(content).top;
      component.setState({
        top: isNaN(parseInt(top_distance)) ? 25 : parseInt(top_distance) || 25
      });
    }
    moment.locale('fr');
    if (state.date && moment().isAfter(state.date, 'day')) {
      component.setState({
        date: moment().format('YYYY-MM-DD')
      });
    }
    if (app.state.session?.user?.id) {
      component.handleSessionChange({
        source: 'DidMount'
      });
    }
    if (props.space || props.spaces_max_bookable) {
      component.pplCheck();
    }
    if (props.etablishment) {
      const type = component.typesCheck();
      if (typeof props.onTypeCheck === 'function' && !props.type) {
        props.onTypeCheck(type);
      }
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.space && props.space !== prev_props.space) {
      component.pplCheck();
    } else if (props.spaces_max_bookable && props.spaces_max_bookable !== prev_props.spaces_max_bookable) {
      component.pplCheck();
    } else if (props.etablishment && props.etablishment !== prev_props.etablishment) {
      const type = component.typesCheck();
      if (props.onTypeCheck) props.onTypeCheck(type);
    } else if (state['widget-space-type'] !== prev_state['widget-space-type'] || props.available_spaces_types !== prev_props.available_spaces_types) {
      const [type_options, type_options_key] = getTypesOptions({
        b2b: state.b2b,
        available_spaces_types: props.available_spaces_types
      });
      let is__dirty = type_options.length !== state.type_options.length;
      if (!is__dirty) {
        is__dirty = type_options.some(function (opt) {
          const state_match = state.type_options.some(state_opt => state_opt.value === opt.value);
          return !state_match;
        });
      }
      if (is__dirty) {
        component.setState({
          type_options: type_options,
          type_options_key: type_options_key
        });
      }
    }
  }
  pplCheck = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const picked_ppl = window.localStorage.getItem('widget-people');
    let max = props.space ? getSpaceMaxBookable(props.space) : 0;
    if (!props.space && props.spaces_max_bookable) {
      max = component.getSeats();
    }
    if (max > 0 && picked_ppl > max) {
      window.localStorage.setItem('widget-people', '');
      component.setState({
        'widget-people': ''
      });
    }
  };
  getSeats = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const space_type = state['widget-space-type'];
    const match = coworking_place_types.find(opt => [opt.value, opt.new_value].includes(space_type));
    if (match) {
      return num(props.spaces_max_bookable[match.value], 0);
    }
    return num(props.spaces_max_bookable.all, 0);
  };
  typesCheck = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const widget_type = window.localStorage.getItem('widget-space-type');
    if (state.b2b) {
      window.localStorage.setItem('widget-space-type', 'lounge');
      component.setState({
        'widget-space-type': 'lounge',
        type_options: coworking_place_types.filter(opt => opt.new_value === 'lounge').map(opt => ({
          label: opt.widget_label,
          value: opt.new_value
        }))
      });
      return 'lounge';
    }

    // aucun type d'espace dispo à l'établissement
    if (props.available_spaces_types?.length > 0 === false) {
      if (widget_type && widget_type !== 'all') {
        component.setState({
          'widget-space-type': 'all',
          type_options: [{
            label: 'Tous nos espaces',
            value: 'all'
          }]
        });
      }
      return 'all';
    }
  };
  handleChange = ({
    ...params
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      name,
      value
    } = params;
    if (name === 'widget-space-type' && (!value || value === 'b_seminar')) {
      component.setState({
        'widget-people': ''
      });
    }
    if (name === 'widget-space-type') {
      component.pplCheck();
    }
    if (name === 'widget-people') {
      if (num(value) > 0 === false) {
        params.value = '1';
      } else {
        const max = num(props.space?.max_number_seat, 0);
        if (max > 0 && value > max) {
          params.value = String(max);
        }
      }
    }
    if (name === 'widget-date') {
      window.localStorage.setItem('widget-date', value);
      component.applyDateFilter({
        date: value
      });
    }
    handleChange.bind(this)({
      ...params
    });
  };
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'documentScroll',
      cb: component.handleScroll
    });
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    app.delete({
      event: 'ShowCustomerWidgetDate',
      cb: component.openDatePicker
    });
    app.delete({
      event: 'UpdateSideWidgetDate',
      cb: component.updateDate
    });
  }
  handleSessionChange = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      roles: app.state.session?.user?.roles || []
    });
  };
  updateDate = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      'widget-date': window.localStorage.getItem('widget-date') || ''
    });
    app.emit({
      event: 'UpdatedSideWidget',
      source: 'SideWidget'
    });
  };
  openDatePicker = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.date_ref?.current?.click();
  };
  applyDateFilter = ({
    date
  }) => {
    const component = this,
      props = this.props,
      state = this.state;

    // le changement ne serait pas détectable vu qu'on emet aucune donnée, tout
    // passe par le localStorage
    if (props['do-not-save']) return;
    window.localStorage.setItem('widget-date', date || state['widget-date']);
    app.emit({
      event: 'UpdatedSideWidget',
      source: 'SideWidget',
      data: {
        scrollToAvailability: true
      }
    });
    if (typeof props.onDateChange === 'function') {
      props.onDateChange({});
    }
  };
  applyFilters = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const state_space_type = state['widget-space-type'];
    if (props['do-not-save'] !== true) {
      window.localStorage.setItem('widget-people', state['widget-people']);
      window.localStorage.setItem('widget-date', state['widget-date']);
      window.localStorage.setItem('widget-space-type', state_space_type);
      app.emit({
        event: 'UpdatedSideWidget',
        source: 'SideWidget',
        data: {
          scrollToAvailability: true
        }
      });
    }
    if (typeof props.onApply === 'function' && state_space_type) {
      props.onApply({
        type: state_space_type
      });
    }
  };
  handleScroll = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const widget = component.ref?.current;
    if (window.innerWidth < 768) return;
    if (!widget) return;
    const pos = widget.getBoundingClientRect();
    const widget_size = widget.querySelector('.js-widget-content').getBoundingClientRect();
    if (component.fixed === true) {
      const is_fully_visible = pos.top > (state.top || 0) && pos.top + widget_size.height < window.innerHeight;
      if (is_fully_visible) {
        component.fixed = false;
        component.setState({
          fixed: false
        });
      }
    } else if (pos.top <= (state.top || 0)) {
      component.fixed = true;
      component.setState({
        fixed: true
      });
    }
  };
  addOnePeople = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const value = String(num(num(state['widget-people'], 0) + 1, 0));
    const max = num(props.space?.max_number_seat, 0);
    component.setState({
      'widget-people': value > 0 === false ? '1' : max > 0 && value > max ? String(max) : value
    });
  };
  removeOnePeople = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const value = String(num(num(state['widget-people'], 0) - 1, 0));
    const max = num(props.space?.max_number_seat, 0);
    component.setState({
      'widget-people': value > 0 === false ? '1' : max > 0 && value > max ? String(max) : value
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const modifiers = (props.bemit || []).slice(0);
    if (state.fixed === true) modifiers.push('fixed');
    const space_type = coworking_place_types.find(opt => [opt.value, opt.new_value].includes(props.space?.type))?.new_value;

    // si un espace est passé en props, affiche en texte le type au lieu d'un sélect
    // utilisé sur la page d'un espace
    const type_infos = coworking_place_types.find(opt => [opt.value, opt.new_value].includes(props.space?.type));
    const type = type_infos ? /*#__PURE__*/React.createElement("p", {
      className: "c-side-widget__item-name"
    }, type_infos.label) : props.space ? '-' : /*#__PURE__*/React.createElement(Select, {
      className: "c-side-widget__select",
      name: "widget-space-type",
      onChange: component.handleChange,
      value: state['widget-space-type'],
      options: state.type_options,
      id: state.type_id,
      status: state.status_messages,
      "no-value-option": false,
      key: state.type_options_key
    });
    const show_people_input = props.space?.type ? !['b_seminar', 'meeting'].includes(props.space.type) : state['widget-space-type'] !== 'meeting';
    const people_max = !show_people_input ? 0 : props.space ? num(props.space?.max_number_seat, 0) : props.spaces_max_bookable ? component.getSeats() : 0;
    const people = show_people_input ? /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__element people"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: state.people_id,
      className: "c-side-widget__label"
    }, "Si\xE8ge(s)", people_max > 0 ? ' (' + people_max + ' max)' : undefined), /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__container"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-btn', ['less']) + ' u-margin-right-10',
      onClick: component.removeOnePeople,
      disabled: num(state['widget-people'], 0) > 1 === false
    }, "- 1 si\xE8ge"), /*#__PURE__*/React.createElement(TextInput, {
      className: "c-side-widget__input",
      name: "widget-people",
      onChange: component.handleChange,
      value: state['widget-people'],
      id: state.people_id,
      status: state.status_messages,
      "safe-value": true,
      int: true,
      inputMode: "numeric",
      min: "1",
      max: people_max > 0 ? String(people_max) : undefined
    }), /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-btn', ['more']) + ' u-margin-left-10',
      onClick: component.addOnePeople,
      disabled: people_max > 0 === false ? undefined : num(state['widget-people'], 0) > people_max - 1
    }, "+ 1 si\xE8ge"))) : undefined;
    const city = props.space ? props.space._etablishment?.address?.city : props.city;
    const date = /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__element date"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: state.date_id,
      className: "c-side-widget__label"
    }, "Date"), /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['widget-date'],
      name: "widget-date",
      id: state.date_id,
      "btn-ref": component.date_ref,
      "allow-no-value": true,
      status: state.status_messages,
      "no-past": true,
      "btn-class": bemit('c-flat-btn', ['blue', 'front', 'side-widget-date'])
    }));
    const update_btn = /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__element validate"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: component.applyFilters,
      className: bemit('c-flat-btn', ['front', 'side-widget-btn'])
    }, "Voir les disponibilit\xE9s"));
    const space_type_selection = /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__element type"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: state.type_id,
      className: "c-side-widget__label"
    }, "Type d'espace"), type);
    let output = /*#__PURE__*/React.createElement("div", {
      className: bemit('c-side-widget', modifiers),
      ref: component.ref
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__content js-widget-content"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "c-side-widget__title"
    }, "Disponibilit\xE9s"), /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__element city"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-side-widget__label"
    }, "Ville"), /*#__PURE__*/React.createElement("p", {
      className: "c-side-widget__item-name"
    }, city)), props.space ? /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__element space"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__label"
    }, "Espace"), /*#__PURE__*/React.createElement("p", {
      className: "c-side-widget__item-name"
    }, props.space?.name)) : undefined, props.space && !state.roles.includes('company_employee') ? space_type_selection : undefined, date, !props.space && !state.roles.includes('company_employee') ? space_type_selection : undefined, people, update_btn));
    return output;
  }
}
